"use client";

import { c as _c } from "react/compiler-runtime";
import { ProxyMode } from "../UserPageProxy";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import ProxyCreateTargetSearch from "./target/ProxyCreateTargetSearch";
import { useMutation } from "@tanstack/react-query";
import type { ApiCreateNewProfileProxy } from "@/generated/models/ApiCreateNewProfileProxy";
import { commonApiPost } from "@/services/api/common-api";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import { useContext, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import ProxyCreateAction from "../proxy/create-action/ProxyCreateAction";
export default function ProxyCreate(t0) {
  const $ = _c(37);
  const {
    profileProxies,
    onModeChange
  } = t0;
  const {
    requestAuth,
    setToast
  } = useContext(AuthContext);
  const {
    setProfileProxy,
    onProfileProxyModify
  } = useContext(ReactQueryWrapperContext);
  const [submitting, setSubmitting] = useState(false);
  const [newProfileProxy, setNewProfileProxy] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = result => {
      setNewProfileProxy(result);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== setToast) {
    t2 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[1] = setToast;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setSubmitting(false);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = {
      mutationFn: _temp,
      onSuccess: t1,
      onError: t2,
      onSettled: t3
    };
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const createProxyMutation = useMutation(t4);
  let t5;
  if ($[6] !== profileProxies) {
    t5 = target => profileProxies?.find(proxy => proxy.granted_to.handle?.toLowerCase() === target.handle?.toLowerCase()) ?? null;
    $[6] = profileProxies;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const alreadyProxied = t5;
  let t6;
  if ($[8] !== alreadyProxied || $[9] !== createProxyMutation || $[10] !== requestAuth) {
    t6 = async target_0 => {
      if (!target_0?.profile_id) {
        setNewProfileProxy(null);
        return;
      }
      const existingProxy = alreadyProxied(target_0);
      if (existingProxy) {
        setNewProfileProxy(existingProxy);
        return;
      }
      setSubmitting(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setSubmitting(false);
        return;
      }
      await createProxyMutation.mutateAsync({
        target_id: target_0.profile_id
      });
    };
    $[8] = alreadyProxied;
    $[9] = createProxyMutation;
    $[10] = requestAuth;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const onTargetSelect = t6;
  let t7;
  if ($[12] !== newProfileProxy || $[13] !== onModeChange || $[14] !== onProfileProxyModify || $[15] !== setProfileProxy) {
    t7 = () => {
      if (!newProfileProxy?.granted_to?.handle || !newProfileProxy?.created_by?.handle) {
        return;
      }
      setProfileProxy(newProfileProxy);
      onProfileProxyModify({
        profileProxyId: newProfileProxy.id
      });
      onModeChange(ProxyMode.LIST);
    };
    $[12] = newProfileProxy;
    $[13] = onModeChange;
    $[14] = onProfileProxyModify;
    $[15] = setProfileProxy;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const onActionCreated = t7;
  let t8;
  if ($[17] !== onModeChange) {
    t8 = () => onModeChange(ProxyMode.LIST);
    $[17] = onModeChange;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t10;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <svg className="tw-flex-shrink-0 tw-w-5 tw-h-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    t10 = <span>Back</span>;
    $[19] = t10;
    $[20] = t9;
  } else {
    t10 = $[19];
    t9 = $[20];
  }
  let t11;
  if ($[21] !== submitting || $[22] !== t8) {
    t11 = <div className="tw-mb-4"><button onClick={t8} disabled={submitting} type="button" className="tw-py-2 tw-px-2 -tw-ml-2 tw-flex tw-items-center tw-gap-x-2 tw-justify-center tw-text-sm tw-font-semibold tw-border-0 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out tw-cursor-pointer tw-text-iron-400 tw-bg-transparent hover:tw-text-iron-50">{t9}{t10}</button></div>;
    $[21] = submitting;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== newProfileProxy || $[25] !== onTargetSelect || $[26] !== submitting) {
    t12 = <ProxyCreateTargetSearch profileProxy={newProfileProxy} loading={submitting} onTargetSelect={onTargetSelect} />;
    $[24] = newProfileProxy;
    $[25] = onTargetSelect;
    $[26] = submitting;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== newProfileProxy || $[29] !== onActionCreated) {
    t13 = newProfileProxy && <ProxyCreateAction profileProxy={newProfileProxy} onActionCreated={onActionCreated} />;
    $[28] = newProfileProxy;
    $[29] = onActionCreated;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13) {
    t14 = <div className="tw-mt-6">{t13}</div>;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t11 || $[34] !== t12 || $[35] !== t14) {
    t15 = <div>{t11}{t12}{t14}</div>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
}
async function _temp(body) {
  return await commonApiPost({
    endpoint: "proxies",
    body
  });
}